<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Thông tin người khuyết tật</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button class="flex items-center justify-center" nz-button nzTooltipTitle="Import" nzTooltipPlacement="bottom"
          nz-tooltip (click)="ImportData()">
          <i nz-icon nzType="import" nzTheme="outline"></i>
        </button>
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
        <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Thêm"
          nzTooltipPlacement="bottom" nz-tooltip (click)="PopupAdd()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
          nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button class="flex items-center justify-center" nz-button (click)="ImportData()">Import học sinh </button>
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">Xuất excel </button>
        <button class="flex items-center justify-center" nz-button (click)="PopupAdd()">Thêm </button>
        <button class="flex items-center justify-center" nz-button (click)="deleteMulti()">Xóa </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button class="flex items-center justify-center" nz-button (click)="ImportData()">
          <i nz-icon nzType="import" nzTheme="outline"></i>Import học sinh
        </button>
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
        <button class="flex items-center justify-center" nz-button (click)="PopupAdd()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          Thêm
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button (click)="deleteMulti()">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
          Xóa
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2"  [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getProvinceACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
          <asc-autocomplete [ascModel]="schoolControl" [disabled]="isDisabled"
            [placeholder]="'Chọn cơ sở...'" [getListAC]="getSchoolACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
      <ng-container *ngIf="isCollapse == false">
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="ma">Mã định danh</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input [(ngModel)]="commonFilter.StudentCode" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập mã định danh...'" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="hoTen">Họ tên</nz-form-label>
            <nz-form-control nzSpan="24">
              <input type="text" nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}"
                [placeholder]="'Nhập họ tên...'" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Dân tộc</nz-form-label>
            <asc-autocomplete [ascModel]="FolkControl" (ascModelChange)="changeFolk($event)"
              [placeholder]="'Chọn dân tộc...'" [getListAC]="getFolkACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Giới tính</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="1">Nam</label>
                <label nz-radio [nzValue]="0">Nữ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Dạng tật</nz-form-label>
            <asc-autocomplete [ascModel]="TypeOfDisabilityControl" (ascModelChange)="changeTypeOfDisability($event)"
              [placeholder]="'Chọn dạng...'" [getListAC]="getTypeOfDisabilityACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Mức độ khuyết tật</nz-form-label>
            <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevel($event)"
              [placeholder]="'Chọn mức độ khuyết tật...'" [getListAC]="getLevelACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Giấy chứng nhận KT</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group [(ngModel)]="commonFilter.disDisabilityCertificateType"
                [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="0">Có</label>
                <label nz-radio [nzValue]="1">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
      <div *ngIf="this.divisibleForFour" nz-col nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">hi</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          (click)="toggleCollapse()" nz-tooltip><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon nzType="clear"
              nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'">Tìm kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="listStudent"
      [nzFrontPagination]="false" nzSize="small" [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full"
      [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)"
      (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzLoading]="loading">
      <thead>
        <tr #pageHeaderTable>
          <th nzLeft nzWidth="50px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"></th>
          <th nzWidth="50px" nzLeft>STT</th>
          <th nzLeft nzWidth="115px">Mã định danh</th>
          <th nzLeft nzWidth="200px">Họ tên</th>
          <th nzLeft nzWidth="100px">Năm sinh</th>
          <th nzWidth="50px">Giới tính</th>
          <th nzWidth="200px">Tên người giám hộ</th>
          <th nzWidth="100px">SĐT người giám hộ</th>
          <th nzWidth="110px">Chứng nhận KT</th>
          <th nzWidth="250px">Loại khuyết tật</th>
          <th nzWidth="150px">Mức độ</th>
          <th nzRight nzWidth="60px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Table.data; let i = index">
          <td nzLeft [nzChecked]="setOfCheckedId.has(item.id)" (nzCheckedChange)="onItemChecked(item.id, $event)"></td>
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{item.studentCode}}</td>
          <td nzLeft>{{item.fullName}}</td>
          <td nzLeft>{{item.yearOfBirth }}</td>
          <td>{{item.gender == 0 ? "Nữ" : item.gender == 1 ? "Nam" : "Khác"}}</td>
          <td>{{item.tutorName}}</td>
          <td>{{item.tutorPhone}}</td>
          <td>
            {{item.disDisabilityCertificateType == 0 ? "Có" : item.disDisabilityCertificateType == 1 ? "Không" :
            item.disDisabilityCertificateType == 2 ? "Nghi ngờ khuyết tật" : ""}}
          </td>
          <td nzTooltipTitle="{{item.typeOfDisabilityName}}" nzTooltipPlacement="top" nz-tooltip class="text-hidden">
            {{item.typeOfDisabilityName}}</td>
          <td>{{item.levelName}}</td>
          <td nzRight>
            <table-btn-row [isEditBtn]="true" [isInfoBtn]="true" (info)="PopupView(item)" (edit)="PopupEdit(item)">
            </table-btn-row>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ total }} </ng-template>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>{{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
